/**
 * ADD-ACCOUNT-BUTTON
 * Button to create a new account (as supervisor) with its modal
 */

import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { store } from "@/index"
import Button from "@/components/button"
import AddAccountModal from "@/modals/add-account.modal"
import { accountAdd } from "@/redux/account.actions"
import { subscriptionGet } from "@/redux/subscription.actions"
import { Session } from "@/redux/_session.types"

//Init a new account (as supervisor) before opening the add account modal
export function initAccount(session: Session) {
  store.dispatch(accountAdd(session.supervisorId, session.userFirstname, session.userLastname))
  store.dispatch(subscriptionGet([]))
}

function AddAccountButton() {
  const { t } = useTranslation()
  const _session: Session = useSelector((state: any) => state._session)
  const [isModalOpen, setIsModalOpen] = useState(false)

  //Add new account
  function addAccount() {
    initAccount(_session)
    setIsModalOpen(true)
  }

  return (
    <>
      {isModalOpen && <AddAccountModal onClose={() => setIsModalOpen(false)} />}
      <Button icon={faPlus} isWithBorder className="secondary" onClick={addAccount}>
        {t("account_create")}
      </Button>
    </>
  )
}

export default AddAccountButton
